/* eslint-disable react/jsx-props-no-spreading */
// @flow
import React, { useState } from 'react';
import classnames from 'classnames';
import Icon from '../Icon';
import { P } from '../Typography';
import styles from './styles.module.scss';
import { ReactComponent as Copy } from '../../assets/icons/copy.svg';

export type InputProps = {
  value?: string,
  error?: string,
  placeholder?: string,
  onChange?: (event: SyntheticInputEvent<HTMLInputElement>) => void,
  type?: 'password' | 'text' | 'number' | 'search' | 'copy',
  name?: string,
  currency?: string,
  className?: string,
  containerClassName?: string,
  size?: 'md' | 'sm',
  onButtonClick?: () => void,
};

const Input = React.forwardRef<*, HTMLInputElement>(
  (
    {
      value,
      onChange,
      placeholder,
      error = '',
      type = 'text',
      name = '',
      className = '',
      currency = '',
      containerClassName = '',
      size = 'md',
      onButtonClick,
      ...rest
    }: InputProps,
    ref,
  ) => {
    const [isShowPassword, setIsShowPassword] = useState<boolean>(false);
    const iconEye = isShowPassword ? <Icon icon="eye" /> : <Icon icon="eye-slash" />;
    const typeSwitch = isShowPassword ? 'text' : type;

    const onShowPassword = () => {
      setIsShowPassword(!isShowPassword);
    };
    return (
      <div className={classnames(styles.inputContainer, containerClassName)}>
        <div className={classnames(styles.inputWrapper, className, styles[size])}>
          <input
            {...rest}
            ref={ref}
            type={typeSwitch}
            lang="en"
            className={classnames(
              styles.input,
              styles[size],
              type === 'search' ? styles.input_search : '',
              currency ? styles.input_currency : '',
              type === 'password' ? styles.input_password : '',
              type === 'copy' ? styles.input_password : '',
              {
                [styles.error]: !!error,
              },
            )}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
          />
          {type === 'search' && (
            <div className={styles['icon-magnifier']}>
              <Icon icon="search" />
            </div>
          )}
          {type === 'copy' && (
            <button
              type="button"
              className={`${styles.iconWrapper} ${styles.leftBorder}`}
              onClick={onButtonClick}
              tabIndex="-1"
            >
              <Copy />
            </button>
          )}
          {currency && <div className={styles.currency}>{currency}</div>}
          {type === 'password' ? (
            <button
              type="button"
              className={`${styles.iconWrapper}`}
              onClick={onShowPassword}
              tabIndex="-1"
            >
              {iconEye}
            </button>
          ) : null}
        </div>
        {error && <P use="error">{error}</P>}
      </div>
    );
  },
);

export default Input;
